// extracted by mini-css-extract-plugin
module.exports = {"sideBar":"SideBar_sideBar__1jMWG","active_menu":"SideBar_active_menu__2AL6_","inactive_menu":"SideBar_inactive_menu__FipE6"};